import React, { Component } from 'react';
import { Query } from 'react-apollo'
import gql from 'graphql-tag'

const prepareData = (edges) => {
  return edges.map(edge => {
    const node = { ...edge.node }
    
    if (node.childItems) {
      node.childItems = prepareData(node.childItems.edges)
    }
    
    return node
  })
}

export default (getQuery, key = 'employees') => WrappedComponent => class WithEmployees extends Component {
  render() {
    return (
      <Query
        query={gql`
          {
            employees(first: 999) {
              edges {
                node {
                  id
                  title
                  position
                  email
                  text
                  menuOrder
                  image {
                    sourceUrl
                  }
                }
              }
            }
          }
        `}
      >
        {({ loading, error, data }) => (
          <div>
            {!error &&
              <WrappedComponent
                {...this.props}
                {...{
                  [`${key}Loading`]: loading,
                  [key]: !loading ? prepareData(data[key].edges) : []
                }}
              />
            }
            {error && <h1>Error: {error.message}</h1>}
          </div>
        )}
      </Query>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/withEmployees.js